import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';

import {ScreenTracker} from '../../../utils/ScreenTracker';
import {CLARITY_UNMASK} from '../../../utils/clarity/unmask';
import {MOBILE_EVENTS} from '../mobileContinue';

/**
 * Debajo de las plataformas, sólo en el celular y sin nada conectado (UD-23, versión del 01/11).
 *
 * No ofrece una acción: dice lo que ya pasó. El correo de bienvenida (P0 del motor) sale en el segundo
 * del alta con el link a este paso, así que quien no tiene a mano la cuenta de Google Ads o de Meta
 * puede irse tranquilo y volver cuando la tenga. Va debajo y chica a propósito: el camino principal es
 * conectar desde acá.
 */
export function MobileLaterNote() {
    const {t} = useTranslation();

    useEffect(() => {
        ScreenTracker.recordEvent(MOBILE_EVENTS.noteShown);
    }, []);

    return (
        <p className="ob-mobile-later" {...CLARITY_UNMASK}>{t('onboarding.mobile.later_note')}</p>
    );
}
